import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoPipe } from '@jsverse/transloco';
import { LangService } from '../lang.service';

@Component({
  selector: 'lib-language-selector',
  templateUrl: './language-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatSelectModule, MatMenuModule, MatButtonModule, TitleCasePipe, TranslocoPipe],
})
export class LanguageSelectorComponent {
  private readonly langService = inject(LangService);

  readonly value = this.langService.language;
  readonly options = this.langService.languages;

  localeChange(value: string): void {
    this.langService.language.set(value);
  }
}
